import uniqBy from 'lodash/uniqBy';
import pick from 'lodash/pick';

// export function getContracts(groups) {
//   if (!groups || groups.length === 0) return [];
//   const allContracts = groups.map(g => pick(g, ['idContract', 'contractName']));
//   return uniqBy(allContracts, c => c.idContract);
// }

export function getNetworkOptions(param) {
  if (!param || param.length === 0) return [];
  const allNetworks = param.map(el => ({ value: el.idContract, label: el.name }));
  return uniqBy(allNetworks, el => el.value);
}

export function getEvaluationOptions(param) {
  if (!param || param.length === 0) return [];
  const allEvaluations = param.map(el => ({ value: el.idESEvaluation, label: el.identification }));
  return uniqBy(allEvaluations, el => el.value);
}

export function getSchoolOptions(param) {
  if (!param || param.length === 0) return [];
  const allSchools = param.map(el => ({ value: el.idCSchool, label: `${el.name} | ${el.city} - ${el.state}` }));
  return uniqBy(allSchools, el => el.value);
}

export function getCourseOptions(param) {
  if (!param || param.length === 0) return [];
  const allCourses = param.map(el => ({ value: el.idESCourse, label: `${el.name} | ${el.level}` }));
  return uniqBy(allCourses, el => el.value);
}

export function getStudentOptions(param) {
  if (!param || param.length === 0) return [];
  const allStudents = param.map(el => ({ value: el.idStudent, label: el.studentName }));
  return uniqBy(allStudents, el => el.value);
}

export function getInitials(name) {
  if (!name) return '';
  const parts = name.replace(/[^\w\s]/gi, '').split(' ');
  let initials = '';
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].length > 0 && parts[i] !== '' && isNaN(parts[i]) && initials.length < 2) {
      initials += parts[i][0];
    }
  }

  initials = initials.toUpperCase();
  return initials;
}
